module.exports = __webpack_public_path__ + "img/oaFlowData154@3x.b5f3a910.png";